import React, { Component } from 'react'
import { pure } from 'recompose'
import { Grid, Row, Col } from 'react-flexbox-grid'
import ClubSelect from 'components/ClubSelect'
import Info from 'components/Info'
import Message from 'components/Message'

class RegistrationForm  extends Component {
    
    state = { 
        firstName: '',
        lastName: '',
        title: '',
        email: '',
        phone: '',
        golfClub: {},
    }


    setClub = (value) => {
        const golfClub = value || {}
        this.setState({ golfClub })
    }

    setValue = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    formSubmit = (event) => {
        event.preventDefault()
        const { onSubmit } = this.props
        const {
            firstName,
            lastName,
            title,
            email,
            phone,
            golfClub,
        } = this.state
        
        onSubmit({
            firstName: firstName,
            lastName: lastName,
            title: title,
            email: email,
            phone: phone,
            golfClub: golfClub.id
        })
    }

    render() {
        const {
            firstName = '',
            lastName = '',
            title = '',
            email = '',
            phone = '',
            golfClub,
        } = this.state

        const {
            loading = false,
            saved = false,
            iconstr = ''
        } = this.props

        return (
            <Grid fluid>
                <form className="form" onSubmit={event => this.formSubmit(event)}>
                    <div className="fieldset-wrap">
                        <fieldset className="fieldset">
                            <legend className="legend">
                                Register as a Golf Pro<br />
                                <small>
                                    Fill in the registration form below to create your Birdietime Pro account.
                                </small>
                            </legend>
                            <Row className="form--row">
                                <Col xs={12} md={6}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="firstName">First name</label><br />
                                        <input value={firstName} onChange={this.setValue} required type="text" id="firstName" name="firstName" />
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="lastName">Last name</label><br />
                                        <input value={lastName} onChange={this.setValue} required type="text" id="lastName" name="lastName" />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="form--row">
                                <Col xs={12}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="title">Title</label><br />
                                        <input value={title} onChange={this.setValue} required type="text" id="title" name="title" />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="form--row">
                                <Col xs={12}>
                                    <div className="form-group form-group__with-info info__pin-right">
                                        <label className="label" htmlFor="golfClub">Golf club</label><br />
                                        <ClubSelect
                                            name="golfClub"
                                            id="golfClub"
                                            value={golfClub.id}
                                            onChange={this.setClub}
                                            clearable={false}
                                            required
                                            placeholder="Type to search"
                                        />
                                        <Info className="info__pin-right">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis scelerisque pulvinar neque ut lacinia. Sed ut ultricies orci. Nulla facilisi. Quisque sit amet malesuada metus. Suspendisse scelerisque diam tincidunt nisl dapibus, quis porta nisl vehicula. Morbi vitae sagittis lectus. Fusce tempor mi quis lectus facilisis, vitae venenatis orci pretium.
                                        </Info>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="form--row">
                                <Col xs={12} md={6}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="email">Email</label><br />
                                        <input value={email} onChange={this.setValue} required type="email" id="email" name="email" />
                                    </div>
                                </Col>
                                <Col xs={12} md={6}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="phone">Phone</label><br />
                                        <input value={phone} onChange={this.setValue} required type="tel" id="phone" name="phone" />
                                    </div>
                                </Col>
                            </Row>
                            {/*
                            <Row className="form--row">
                                <Col xs={12}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="companyName">Company Name (optional)</label><br />
                                        <input type="text" id="companyName" name="companyName" />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="form--row">
                                <Col xs={12}>
                                    <div className="form-group">
                                        <label className="label" htmlFor="businessId">Business ID (optional)</label><br />
                                        <input type="text" id="businessId" name="businessId" />
                                    </div>
                                </Col>
                            </Row>
                            */}
                        </fieldset>
                    </div>
                    <div className="form--footer">
                        <p>Please read carefully once again before submitting. Thank you!</p>
                    </div>
                    <div className="form-group form-group--submit">
                        {saved && <Message type="success"><p>Form saved</p></Message>}
                        <button disabled={loading || saved} className="button" type="submit" size="big">
                            SEND FORM
                            <span className="button--icon" dangerouslySetInnerHTML={{ __html: iconstr }} />
                        </button>
                    </div>
                </form>
            </Grid>
        )
    }
}


export default pure(RegistrationForm)



// WEBPACK FOOTER //
// ./src/components/RegistrationForm/RegistrationForm.js